module.exports = __webpack_public_path__ + "img/icon_chip_09.73441977.png";